"use client";
import ChatBot from "../../components/ChatBot";

export default function Page() {
  return <ChatBot />;
}
